<template>
  <div v-if="stock_item && stock_item.stock_item_id">
    <h6 class="m-0">
      <span class="text-muted">TIPO DE REAJUSTE DO MEDICAMENTO:</span>
      {{
        {
          REAJUSTE_MANUAL: "REAJUSTE MANUAL",
          REAJUSTE_VALOR_MEDIO: "REAJUSTE VALOR MÉDIO (AUTOMÁTICO)",
          REAJUSTE_MAIOR_VALOR: "REAJUSTE MAIOR VALOR (AUTOMÁTICO)",
        }[readjustment]
      }}
    </h6>
    <div v-if="item && readjustment == 'REAJUSTE_MANUAL'">
      <div class="d-flex align-items-center" v-if="item.type == 'PRODUCT'">
        <h6 class="m-0">
          <span class="text-muted">VENDA:</span>
          R$
          {{
            item.product_sale ? formatPrice(item.product_sale) : "NÃO INFORMADO"
          }}
        </h6>
      </div>
      <div class="d-flex align-items-center" v-if="item.type == 'MEDICINE'">
        <h6 class="m-0">
          <span class="text-muted">VENDA:</span>
          R$
          {{
            item.medicine_sale
              ? formatPrice(item.medicine_sale)
              : "NÃO INFORMADO"
          }}
        </h6>
      </div>
    </div>
    <div
      class="d-flex align-items-center"
      v-if="item && readjustment == 'REAJUSTE_VALOR_MEDIO'"
    >
      <h6 class="m-0">
        <span class="text-muted">VALOR MÉDIO:</span>
        R$ {{ formatPrice(average) }}
      </h6>
    </div>
    <div
      class="d-flex align-items-center"
      v-if="item && readjustment == 'REAJUSTE_MAIOR_VALOR'"
    >
      <h6 class="m-0">
        <span class="text-muted">MAIOR VALOR:</span>
        R$ {{ formatPrice(average) }}
      </h6>
    </div>
  </div>
</template>

<script>
import api from "../../../../services/api";

import { formatPrice, formatReal } from "../../../../lib/format";

import moment from "moment";

export default {
  name: "StockItemPriceList",

  props: {
    stock_item: { type: Object },
  },

  data() {
    return {
      stock_item_price_list: [],

      item: null,

      readjustment: "REAJUSTE_MANUAL",

      average: 0,

      loading: false,
    };
  },

  watch: {
    stock_item() {
      if (this.stock_item.stock_item_id) {
        this.handleVerifyStockItemPriceList();
      }
    },
  },

  created() {
    let {
      stock_item: { stock_item_id },
    } = this;

    if (stock_item_id) {
      this.handleVerifyStockItemPriceList();
    }
  },

  methods: {
    formatPrice,
    moment,

    async handleVerifyStockItemPriceList() {
      try {
        this.loading = true;

        let {
          stock_item: { stock_item_id },
        } = this;

        let params = { stock_item_id };

        const response = await api.get(
          "/rest-home/stock-sale/item/price-list",
          {
            params,
          }
        );

        const { stock_item_price_list, readjustment, average, stock_item } =
          response.data;

        this.stock_item_price_list = stock_item_price_list;
        this.readjustment = readjustment;
        this.average = average;
        this.item = stock_item;

        this.$emit("type", { readjustment, stock_item });
        this.select();

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    select() {
      let {
        item: { type, product_sale, medicine_sale },
        stock_item,
      } = this;

      let value = type == "PRODUCT" ? product_sale : medicine_sale;

      // let { amount } = stock_item;

      // amount = String(amount).replace(",", ".");

      value = parseFloat(value) / 100;
      value = value.toFixed(2);

      // let value_total = parseFloat(amount) * parseFloat(value);
      let value_total = parseFloat(value);

      stock_item.value_total = formatReal(String(value_total));
      stock_item.value = formatReal(String(value_total));
      stock_item.unitary_value = formatReal(String(value));

      this.$emit("value", { ...stock_item });
    },
  },
};
</script>
